/**
 * Detects whether the user currently has a non-empty text selection on the page.
 * Used to distinguish a plain row click from a mouseup that ends a drag-to-select
 * text selection, since both fire a native 'click' event on the same element.
 */
export const hasActiveTextSelection = (): boolean => {
	const selection = window.getSelection();
	return !!selection && selection.toString().length > 0;
}
